import $ from 'jquery';

import Navigation from '../components/Navigation';
import ThemeUtils from '../utils/ThemeUtils';

export default class StaticHeader {
  constructor(section) {
    this.$el = $(section.el).find('.main-header-wrapper');
    this.window = $(window);
    this.$document = $(document.body);
    this.headerLogo = '[data-header-logo]';
    this.$drawerMenu = this.$document.find('[data-header-drawer]');
    this.$mainContent = $('[data-main-content]');
    this.$mainHeader = this.$el.find('[data-header-content]');
    this.$headerLogo = $(this.headerLogo);
    this.$searchWrapper = this.$el.find('[data-header-search]');
    this.slideShow = '[data-slideshow-container]';
    this.$slideShow = $(this.slideShow);

    // Conditionals
    this.isHeaderNavigation = this.$el.attr('data-main-header') === 'header';
    this.hasLogo = this.$el.find(this.headerLogo).length;
    this.isHeaderSticky = (this.$el.attr('data-sticky-header') != null);

    this.sectionChanges(this.$slideShow, false, null);
    this._bindEvents();

    // Imported Classes
    this.navigation = new Navigation({ el: this.$document });

    if (this.isHeaderNavigation) {
      this.calculateHeaderWidths();
      this.window.resize(() => this.fitHeader());
    }

    if ($('html').hasClass('lt-ie9')) {
      this.verticallyCenterShopName();
      if (this.hasLogo) {
        this.verticallyCenterLogo();
      }
    }
  }

  _bindEvents() {
    this.$document
      .on('shopify:section:select.header', event => this.sectionChanges(null, true, event.originalEvent.detail.sectionId))
      .on('shopify:section:deselect.header', event => this.sectionChanges(null, true, event.originalEvent.detail.sectionId))
      .on('click', '.header-search-toggle', () => this.openSearch())
      .on('blur', '.header-search-input', () => this.closeSearch())
      .on('click', '[data-drawer-toggle]', () => this.toggleCollapsedNav())
      .on('toggleStickyHeader', (event, $slideshow) => this.stickyHeader($slideshow))
      .on('toggleSlideShowHeader', (event, $slideshow) => this.slideShowHeader($slideshow))
      .on('swapLogo', () => this.swapLogo())
      .on('mouseenter', '.has-dropdown', event => this.openSubNav(event))
      .on('mouseleave', '.has-dropdown', event => this.closeSubNav(event));

    this.window.on('resize.header', () => this._resizeEvents());
  }

  unBindEvents() {
    this.$document
      .off('shopify:section:select.header')
      .off('shopify:section:deselect.header')
      .off('.header-search-toggle')
      .off('blur', '.header-search-input')
      .off('click', '[data-drawer-toggle]')
      .off('toggleStickyHeader', this.$el)
      .off('toggleSlideShowHeader', this.$el)
      .off('swapLogo', this.$el);

    this.window.off('resize.header');
  }

  _resizeEvents() {
    this.stickyHeaderOffset(this.isHeaderSticky);

    if (this.$document.hasClass('navigation-below-header')) {
      this.$document.removeClass('navigation-below-header');
      $('.main-header', this.$el).addClass('collapsed-navigation');
    }

    if ((ThemeUtils.windowWidth() >= 720) && this.$document.hasClass('showing-drawer')) {
      if (this.$document.hasClass('navigation-below-header')
        || (this.$document.hasClass('navigation-header')
        && !$('.main-header', this.$el).hasClass('collapsed-navigation'))) {
        this.toggleCollapsedNav();
      }
    }

    this.swapLogo();
  }

  swapLogo() {
    if (!this.$headerLogo.length) { return; }

    const windowWidth = ThemeUtils.windowWidth();
    const hasFullBleedSlideshow = $('[data-full-bleed-slideshow]').length !== 0;

    // Switch back to default logo on mobile, or if is lower than slideshow
    if ((windowWidth < 720) || !hasFullBleedSlideshow || this.$el.hasClass('sticky-header-scrolled')) {
      this.$headerLogo.attr('src', this.$headerLogo.attr('data-src-original'));
      this.$headerLogo.attr('srcset', this.$headerLogo.attr('data-src-original'));
    } else if (hasFullBleedSlideshow) {
      this.$headerLogo.attr('src', this.$headerLogo.attr('data-src-alt'));
      this.$headerLogo.attr('srcset', this.$headerLogo.attr('data-src-alt'));
    }
  }

  getColorSetting() {
    const colorSetting = this.$el.attr('class').match(/header-bleed-.+-colors/);

    if (colorSetting != null) {
      return colorSetting[0];
    }
    return false;
  }

  slideShowHeader($slideShow) {
    if ($slideShow == null) { $slideShow = $(this.slideShow); }

    if ($slideShow.length && $('[data-full-bleed-slideshow]').length) {
      this.$el.addClass('full-bleed-slideshow');
    } else {
      this.$el.removeClass('full-bleed-slideshow');
      this.$el.removeClass(this.getColorSetting());
    }
  }

  stickyHeader($slideShow) {
    if ($slideShow == null) { $slideShow = $(this.slideShow); }
    this.stickyHeaderOffset(this.isHeaderSticky, $slideShow);

    if (!this.isHeaderSticky) { return; }

    const hasSlideshow = $('[data-full-bleed-slideshow]').length;
    const colorSetting = this.getColorSetting();

    if (hasSlideshow && colorSetting) {
      this.$el.attr('data-header-bleed-color', colorSetting);
    }

    this.window.on('scroll', (e) => {
      let scrollPosition = this.window.scrollTop();
      scrollPosition = scrollPosition < 110 ? 0 : scrollPosition;

      if (scrollPosition > 0) {
        this.$el.removeClass('full-bleed-slideshow')
          .addClass('sticky-header-scrolled');
        if (hasSlideshow) { this.$el.removeClass(colorSetting); }
      } else if (scrollPosition === 0) {
        this.$el.removeClass('sticky-header-scrolled');
        if (hasSlideshow) {
          this.$el.addClass('full-bleed-slideshow')
            .addClass(this.$el.attr('data-header-bleed-color'));
        } else {
          this.$el.removeClass('full-bleed-slideshow');
        }
      }

      this.swapLogo();
    });
  }

  stickyHeaderOffset(toggleOn, $slideShow) {
    let $slides;
    if ($slideShow == null) { $slideShow = $(this.slideShow); }
    let offsetHeight = this.$el.outerHeight();
    const $promotionBar = this.$el.find('[data-promotion-bar]');
    const hasFullBleedSlideshow = $('[data-full-bleed-slideshow]').length;
    const hasSlideshow = $slideShow.length;

    // Reset all offsets
    if (hasSlideshow) {
      $slides = $slideShow.find('[data-slide]');
      $slideShow.css({ paddingTop: '', marginTop: '' });

      if ($slides.length) {
        $slides.css({ paddingTop: '', height: '' });

        if (!hasFullBleedSlideshow || (ThemeUtils.windowWidth() < 720)) {
          $slides.find('.slide-text').css({ paddingTop: '', paddingBottom: '' });
        }
      }
    }

    this.$mainContent.css({ paddingTop: '', marginTop: '' });

    if ((!toggleOn && !hasFullBleedSlideshow) || !(ThemeUtils.windowWidth() >= 720)) { return; }

    if (hasSlideshow) {
      if (hasFullBleedSlideshow) {
        let slideOffset = offsetHeight + 50;
        if ($promotionBar.length) {
          const promotionBarHeight = $promotionBar.outerHeight();
          slideOffset -= promotionBarHeight;

          this.$mainContent.css({ paddingTop: promotionBarHeight, marginTop: '' });
        } else {
          this.$mainContent.css({ paddingTop: '', marginTop: '' });
        }

        $slides.find('.slide-text').css({
          paddingTop: slideOffset,
          paddingBottom: 100,
        });
      } else {
        this.$mainContent.css({ marginTop: offsetHeight });
      }
    } else {
      this.$mainContent.css({ marginTop: offsetHeight });
    }
  }

  /*
        Check to see if the header needs a border beneath it
            - Only apply border if
                - There is no slideshow
                - Header background matches body background
                - The first occurrence of '.module-container' has the default style
    */
  borderCheck() {
    const $mainHeader = $('[data-main-header]');
    if (Theme.headerSticky || ($('[data-section-type=slideshow]').length !== 0)) {
      return;
    }

    if ($(document.body).css('background-image') === !'none') {
      return;
    }

    const headerBackground = $mainHeader.css('background-color');
    const bodyBackground = $(document.body).css('background-color');

    if ($('.module-container:first').hasClass('default-style') && (headerBackground === bodyBackground)) {
      $mainHeader.toggleClass('show-border', true);
    }

    $mainHeader.toggleClass('show-border', false);
  }

  /*
        These events need to fire when any section in the TE is reloaded
    */
  sectionChanges($slideshow, isDocumentEvent, sectionId) {
    if (isDocumentEvent && (sectionId === 'static-header')) { return; }

    this.borderCheck();
    this.stickyHeader($slideshow);
    this.slideShowHeader($slideshow);

    this.$headerLogo.on('rimg:load', () => this.swapLogo());
  }

  calculateHeaderWidths() {
    $('img', this.$el).one('rimg:load', () => {
      let brandingWidth = this.$el.find('.branding').outerWidth(true);
      const toolsWidth = this.$el.find('.header-tools').outerWidth(true);

      if ((brandingWidth === 0) && this.$headerLogo.length) {
        brandingWidth = this.$headerLogo.width();
      }

      this.combinedWidth = brandingWidth + toolsWidth;

      this.fitHeader();
    });
  }

  fitHeader() {
    const headerWidth = this.$mainHeader.width();

    // extra 45px for padding
    this.$mainHeader.toggleClass('collapsed-navigation', (this.combinedWidth + 45) > headerWidth);
    this.stickyHeaderOffset(this.isHeaderSticky, null);
  }

  toggleCollapsedNav(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.$document.toggleClass('showing-drawer');

    if (Modernizr.csstransitions) {
      this.$el.one('transitionend', () => this.$document.toggleClass('drawer-visible'));
    }

    this.$document.toggleClass('drawer-visible');
  }

  openSearch() {
    if (window.innerWidth <= 720) {
      window.location.href = '/search';
      return;
    }

    this.$searchWrapper.addClass('active').find('input').focus();

    this.$searchWrapper.on('keyup.search', (e) => {
      if (e.keyCode === 27) {
        this.closeSearch();
      }
    });
  }

  closeSearch() {
    this.$searchWrapper.removeClass('active').off('keyup.search');
  }

  verticallyCenterLogo() {
    $('img', this.$el).one('rimg:load', () => {
      const logoHeight = this.$headerLogo.height();
      $('a.logo img', this.$el).css({ marginTop: (-1 * logoHeight) / 2 });
    });
  }

  verticallyCenterShopName() {
    const shopNameHeight = this.$drawerMenu.find('h1 a').height();
    this.$drawerMenu.find('h1 a').css({ marginTop: (-1 * shopNameHeight) / 2 });
  }

  openSubNav(e) {
    e.stopPropagation();
    this.checkSubNavVisibillity(e);
    this.setExpanded(e);
  }

  closeSubNav(e) {
    e.stopPropagation();
    this.unsetExpanded(e);
  }

  checkSubNavVisibillity(e) {
    const $subNav = $(e.currentTarget).children('ul').eq(0);

    if ($subNav.length) {
      const $subNavPosition = $subNav.offset().left + $subNav.outerWidth();

      if ($subNavPosition > $(window).width()) {
        $subNav.addClass('open-right');
      }
    }
  }

  setExpanded(e) {
    const $link = $(e.currentTarget).find('.dropdown-toggle');
    $link.attr('aria-expanded', true);
  }

  unsetExpanded(e) {
    const $link = $(e.currentTarget).find('.dropdown-toggle');
    $link.attr('aria-expanded', false);
  }

  onSectionUnload() {
    this.unBindEvents();
  }
}
